import React from 'react';
import isPast from 'date-fns/is_past';
import { isLive } from '~/tools/mll/helpers';

const Teams = ({ page }) => (
  <div className='teams'>
    <span className='team-title'>{page.awayTeam.gist.title}
      <span className='at'>AT</span>
    </span>
      <span className='team-title'>{page.homeTeam.gist.title}</span>
  </div>
)

const Event = ({ page, data, faceoffTime }) => (
  <div className='fight-event'>
    <div className='event-title'>{page.title}</div>
    { isPast(faceoffTime) && isLive('EVENT', data) &&
      <div className='event-broadcast site-color'>
        <span className='event-live-icon site-background-color'></span>
        <a href={page.externalUrl} target='_blank'>Watch live</a>
        <i className='ion-share'></i>
      </div> }
  </div>
)

export default {
  Teams : Teams,
  Event : Event
} 